import { Grid, Typography, Box, ButtonBase, SxProps } from '@mui/material';
import { Img } from '@/components/blocks/MaterialImage';
import {
	BenefitImgContainerSX,
	BenefitItemContentSX,
	BenefitItemDescriptionSX,
	BenefitItemTitleSX,
} from '@/components/blocks/Benefits/styles/item';

export const Benefit = ({
	title,
	description,
	imgSrc,
	isTablet,
	onClick,
}: {
	title: string;
	description: string;
	imgSrc: string;
	isTablet: boolean;
	onClick?: () => void;
	sx?: SxProps;
}) => (
	<Grid item>
		<ButtonBase sx={BenefitItemContentSX(isTablet)} onClick={onClick}>
			<Box sx={BenefitImgContainerSX}>
				<Img src={imgSrc} height={'37.5px'} alt={title} />
			</Box>
			<Typography component="h3" sx={BenefitItemTitleSX(isTablet)}>
				{title}
			</Typography>
			<Typography sx={BenefitItemDescriptionSX}>{description}</Typography>
		</ButtonBase>
	</Grid>
);
